import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ScrollReveal } from '../components/ui/ScrollReveal';
import { Button } from '../components/ui/Button';
export function DevelopersPage() {
  return <div className="w-full pt-24" data-id="element-461">
      <section className="py-24 md:py-32 bg-brand-green-deep text-brand-cream-light relative overflow-hidden" data-id="element-462">
        <div className="absolute inset-0 bg-gradient-to-br from-brand-charcoal to-brand-green-deep opacity-80" data-id="element-463" />
        <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-464">
          <SectionHeading eyebrow="Developers" title="Distinctive amenities that add identity and value." subtitle="Differentiate your community or building with premium golf-inspired spaces." light data-id="element-465" />
        </div>
      </section>

      <section className="py-24 bg-brand-cream-light" data-id="element-466">
        <div className="max-w-7xl mx-auto px-6" data-id="element-467">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-468">
            <ScrollReveal data-id="element-469">
              <div className="aspect-[4/3] bg-gradient-to-tr from-brand-stone to-brand-cream rounded-sm" data-id="element-470" />
            </ScrollReveal>
            <div className="flex flex-col justify-center" data-id="element-471">
              <ScrollReveal delay={0.2} data-id="element-472">
                <h2 className="text-4xl font-heading text-brand-green-deep mb-6" data-id="element-473">
                  Amenity Differentiation
                </h2>
                <p className="text-lg font-body text-brand-stone mb-8" data-id="element-474">
                  In a competitive real estate market, standard amenities aren't
                  enough. PuttLab designs rooftop putting lounges, podium-level
                  social greens, and clubhouse features that act as a primary
                  selling point for prospective buyers and tenants.
                </p>
                <Button variant="dark" href="/contact" data-id="element-475">
                  Partner With Us Early
                </Button>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </section>
    </div>;
}